// 📁 shared-constants/courier/courierProviders.ts
// 사용처: farmfree-functions, farmfree-admin
// ⚠️ 이 파일은 COURIER_INFO_MAP의 래퍼입니다. 데이터 추가/수정은 courierCodes.ts에서 하세요.

import { COURIER_INFO_MAP, type CourierCode, type CourierInfo } from './courierCodes'

// CourierInfo 타입을 재export하여 다른 파일에서 사용 가능하도록 함
export type { CourierInfo } from './courierCodes'

/**
 * 택배사 ID 타입
 * COURIER_INFO_MAP의 CourierCode와 동일
 */
export type CourierProviderId = CourierCode

/**
 * 택배사 정보 조회 (COURIER_INFO_MAP 기반)
 * 전체 CourierInfo 반환 (2FA 설정 포함)
 */
export const getProviderInfo = (providerId: string | undefined): CourierInfo | null => {
  if (!providerId) return null
  const info = COURIER_INFO_MAP[providerId.toLowerCase() as CourierCode]
  return info || null
}

/**
 * 활성화된 택배사 목록 조회 (COURIER_INFO_MAP 기반)
 * supportsTracking 또는 supportsAccount 중 하나라도 true인 택배사 반환
 */
export const getActiveProviders = (): CourierInfo[] => {
  return Object.values(COURIER_INFO_MAP).filter(
    (info) => info.supportsTracking || info.supportsAccount
  )
}

/**
 * 택배사 아이콘 조회
 */
export const getProviderIcon = (providerId: string): string => {
  const provider = getProviderInfo(providerId)
  return provider?.icon || ''
}

/**
 * 택배사 명칭 조회
 */
export const getProviderDisplayName = (providerId: string): string => {
  const provider = getProviderInfo(providerId)
  return provider?.displayName || ''
}
